import { Paper } from '@mui/material';
import Stack from '@mui/material/Stack';

import FinalReportHeader from './finalReportHeader';
import TemplateGrid from './templateGrid';

import { useTenantSlug } from '~/features/tenant/helpers';
import { FinalReportService } from '~/services/api/final-report/endpoints';
import QueryResolver from '~/services/api/query-resolver';

const FinalReport = () => {
  const slug = useTenantSlug();
  const query = FinalReportService.endpoints.templates.useQuery({ slug });

  return (
    <Paper
      elevation={0}
      sx={{
        width: '100%',
        borderTopLeftRadius: '0px',
        borderTopRightRadius: '0px',
        borderBottomRightRadius: '8px',
        borderBottomLeftRadius: '8px',
        borderLeft: '1px solid rgba(0, 0, 0, 0.16)',
        borderRight: '1px solid rgba(0, 0, 0, 0.16)',
        borderBottom: '1px solid rgba(0, 0, 0, 0.16)',
        bgcolor: '#FFF',
        height: '100%',
      }}
    >
      <QueryResolver query={query}>
        {(data) => (
          <Stack spacing={2} padding='20px' height='100%'>
            <FinalReportHeader />
            <TemplateGrid items={data} />
          </Stack>
        )}
      </QueryResolver>
    </Paper>
  );
};

export default FinalReport;
